'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sanitizeHtml = exports.config = undefined;

var _sanitizeHtml = require('sanitize-html');

var _sanitizeHtml2 = _interopRequireDefault(_sanitizeHtml);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var config = exports.config = {
  allowedTags: ['a', 'abbr', 'b', 'br', 'del', 'div', 'em', 'hr', 'i', 'iframe', 'img', 'p', 'pre', 's', 'small', 'span', 'strike', 'strong', 'sub', 'sup', 'u'],
  allowedAttributes: {
    a: ['href'],
    abbr: ['title'],
    iframe: ['src'],
    img: ['alt', 'src']
  }
};

var sanitizeHtml = exports.sanitizeHtml = function sanitizeHtml(html) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : config;
  return (0, _sanitizeHtml2.default)(html, options);
};

exports.default = sanitizeHtml;